import { handleActions } from 'redux-actions'
import update from 'immutability-helper'
import * as actions from './dataOverview.actions'

const initialState = {
    peopleTagCount: [],
    sunburstChartData: [],
    mapChartData: [],
    kLineChartData: [],
    idTrendChartData: [],
    sunburstChartErrorData: {},
    ageReport: [],
    genderReport: [],
    appReport: [],
    internetReport: []
}

export type DataOverviewState = {
    peopleTagCount: any[]
    sunburstChartData: any[]
    mapChartData: any[]
    kLineChartData: any[]
    idTrendChartData: any[],
    sunburstChartErrorData: any,
    ageReport: any[],
    genderReport: any[],
    appReport: any[],
    internetReport: any[]
}

export default handleActions<DataOverviewState>({
    [actions.RECEIVE_PEOPLE_TAG_COUNT]: (state: any, { payload }) => {
        return update(state, {
            peopleTagCount: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_SUNBURST_CHART_DATA]: (state: any, { payload }) => {
        return update(state, {
            sunburstChartData: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_SUNBURST_CHART_ERROR_DATA]: (state: any, { payload }) => {
        return update(state, {
            sunburstChartErrorData: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_MAP_CHART_DATA]: (state: any, { payload }) => {
        return update(state, {
            mapChartData: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_K_LINE_CHART_DATA]: (state: any, { payload }) => {
        return update(state, {
            kLineChartData: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_ID_TREND_CHART_DATA]: (state: any, { payload }) => {
        return update(state, {
            idTrendChartData: { 
                $set: (payload as any) 
            },
        })
    },
    [actions.RECEIVE_BASE_CHART_DATA]: (state: any, { payload }) => {
        return update(state, {
            [(payload as any).type]: { 
                $set: (payload as any).data
            },
        })
    },
}, initialState)
